import { getWindowWidth, getWindowHeight, getWindowScrollTop } from 'ava-util/dist/dom-window';
import { addClass, removeClass } from 'ava-util/dist/dom-class';

const DEFAULT_CLASS_NAME = 'add-cart-animate';
const PAUSE_TIME = 400; // 两段动画中间停留时间,
const FADE_IN_TIME = 200; // 出现到停留在屏幕中的时间，与css保持一致
const FLY_OUT_TIME = 200; // 从屏幕中心到cart图片所用时间，与css保持一致

const createBox = (src: string): HTMLDivElement => {
    const image = document.createElement('img');
    image.src = src;
    const box = document.createElement('div');
    box.className = DEFAULT_CLASS_NAME;
    box.appendChild(image);
    document.body.appendChild(box);
    return box;
};

export const singleAddAnimate = async (src: string) => {
    const box = createBox(src);
    addClass(box, 'in', true);
    const winW = getWindowWidth();
    const winH = getWindowHeight();
    const boxW = box.offsetWidth;
    const boxH = box.offsetHeight;
    const boxX = Math.round((winW - boxW) / 2);
    const boxY = Math.round((winH - boxH) / 2);
    box.style.left = `${boxX}px`;
    box.style.top = `${boxY}px`;

    setTimeout(() => {
        removeClass(box, 'in', true);
        const target = document.getElementById('js-cart-icon');
        if (target) {
            const targetW = target.offsetWidth;
            const targetH = target.offsetHeight;
            const targetRect = target.getBoundingClientRect();
            const newBoxX = (targetRect.left + (targetW / 2)) - (boxW / 2);
            let newBoxY = (targetRect.top + (targetH / 2)) - (boxH / 2);
            
            addClass(box, 'out', true);
            box.style.left = `${newBoxX}px`;
            box.style.top = `${newBoxY}px`;
            box.style.transform = `scale(${targetW / boxW})`;
        }
        setTimeout(() => {
            document.body.removeChild(box);
        }, FLY_OUT_TIME + 100);
    }, PAUSE_TIME + FADE_IN_TIME);
}

export const multiAddAnimate = async (srcList: string[]) => {
    if (srcList.length > 0) {
        srcList.forEach((src, i) => {
            if (i === 0) {
                singleAddAnimate(src);
            } else {
                setTimeout(() => {
                    singleAddAnimate(src);
                }, 100 * i);
            }
        });
    }
};